import Bold from '../../atoms/text/bold';
import TextContainer from '../../atoms/text/tip';
import TranslationManager from '../../../../shared/assets/locale/translationsManager';

function Tip() {
  return (
    <TextContainer id={'tipContainer'}>
      {TranslationManager.get('COMPONENTS.TIP.ACTIONS1')}
      <Bold>{TranslationManager.get('COMPONENTS.TIP.ACTIONS_CONFIRM')}</Bold>
      {TranslationManager.get('COMPONENTS.TIP.ACTIONS2')}
    </TextContainer>
  );
}

export default Tip;
